
const API_BASE_URL = "https://transtigoback.transtigo.mg/api";
const API_MDP = "https://transtigoback.transtigo.mg";

export const API = {
  BASE_URL: API_BASE_URL,
  MDP: API_MDP,
  LOGIN: `${API_BASE_URL}/login`,
  REGISTER: `${API_BASE_URL}/register`,
  REFRESH: `${API_BASE_URL}/token/refresh`,
};

export const HOMEAPI= {
   MDP: API_MDP,

};